export enum UserRoles {
  Admin = 'tpdigital_administrator',
  Client = 'tpdigital_client',
  Supplier = 'tpdigital_supplier',
}

export enum UserComplementaryRoles {
  Supplier = 'tpdigital_supplier_external',
}

export type Roles = UserRoles | UserComplementaryRoles
